import React from 'react';

import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea.tsx';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';
import Button from '@/components/ui/buttons/Button.tsx';
import { pageTitles } from '@/constants/pageTitles';

import styles from './InviteEmailCompleteForm.module.scss';

interface Props {
  onNavigateToMypage: () => void;
}

const InviteEmailCompleteForm: React.FC<Props> = ({ onNavigateToMypage }) => (
  <div className={styles.InviteEmailCompleteForm}>
    <Jumbotron>
      <JumbotronPanel panelHeaderTitle={pageTitles.inviteEmailComplete}>
        <JumbotronTitle>招待メールの送信が完了しました</JumbotronTitle>
        <JumbotronDescription>
          「マイページへ」ボタンより引き続き
          <br />
          スタディサプリをご利用ください。
        </JumbotronDescription>
        <JumbotronButtonArea>
          <Button onClick={onNavigateToMypage} size="m" color="primary">
            マイページへ
          </Button>
        </JumbotronButtonArea>
      </JumbotronPanel>
    </Jumbotron>
  </div>
);

export default InviteEmailCompleteForm;
